"use strict";
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useFocusScope = void 0;
var react_1 = require("react");
var tabbable_1 = require("tabbable");
var utilities_1 = require("../utilities");
var focus_utils_1 = require("../utilities/focus-utils");
var react_dom_1 = require("react-dom");
var useFocusScope = function (focusScopeRef, options) {
    var _a = options !== null && options !== void 0 ? options : {}, disableTrapping = _a.disableTrapping, disableAutofocus = _a.disableAutofocus, disableRestoreFocus = _a.disableRestoreFocus, restoreFocusRef = _a.restoreFocusRef;
    var tabbableNodes = react_1.useRef([]);
    var focusScope = react_1.useMemo(function () { return (Array.isArray(focusScopeRef) ? focusScopeRef : [focusScopeRef]); }, [focusScopeRef]);
    var defaultRestoreFocusElement = react_1.useMemo(function () { return focus_utils_1.getActiveElement(); }, []);
    var handleTab = function (e) {
        if (e.code === utilities_1.Keys.Tab) {
            if (disableTrapping)
                return;
            if (tabbableNodes.current.length > 0)
                e.preventDefault();
            e.stopPropagation();
            if (e.shiftKey) {
                focus_utils_1.focusPrev(tabbableNodes.current);
            }
            else {
                focus_utils_1.focusNext(tabbableNodes.current);
            }
        }
    };
    var getElementFromRef = function (ref) {
        if (ref.current instanceof Element)
            return ref.current;
        /**
         * React refs can either be DOM Elements or React Components.
         * Since we use DOM Element methods such as 'contains' and
         * 'querySelectorAll' (tabbable package), we convert the refs
         * here to DOM Element refs. Currently doesn't seem to be a
         * better way besides findDOMNode.
         */
        // eslint-disable-next-line react/no-find-dom-node
        return react_dom_1.findDOMNode(ref.current);
    };
    var autofocus = function () {
        if (tabbableNodes.current.length > 0) {
            focus_utils_1.focusNext(tabbable_1.tabbable(tabbableNodes.current[0], {
                includeContainer: true,
            }));
        }
    };
    var restoreFocus = function () {
        var _a;
        focus_utils_1.tryFocus((_a = restoreFocusRef === null || restoreFocusRef === void 0 ? void 0 : restoreFocusRef.current) !== null && _a !== void 0 ? _a : defaultRestoreFocusElement);
    };
    react_1.useEffect(function () {
        var setTabbableNodes = function () {
            tabbableNodes.current = focusScope.reduce(function (nodes, ref) {
                if (!ref.current)
                    return nodes;
                var element = getElementFromRef(ref);
                return __spreadArrays(nodes, tabbable_1.tabbable(element, { includeContainer: true }));
            }, []);
        };
        !disableTrapping && setTabbableNodes();
    });
    react_1.useEffect(function () {
        var isAlreadyAutofocused = function (ref) {
            var _a, _b;
            var element = getElementFromRef(ref);
            return (_b = (_a = element === null || element === void 0 ? void 0 : element.contains) === null || _a === void 0 ? void 0 : _a.call(element, document.activeElement)) !== null && _b !== void 0 ? _b : false;
        };
        if (disableAutofocus || focusScope.some(isAlreadyAutofocused))
            return;
        autofocus();
    }, [focusScopeRef, disableAutofocus, focusScope]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    react_1.useEffect(function () { return function () { return !disableRestoreFocus && restoreFocus(); }; }, [disableRestoreFocus, focusScopeRef]);
    return { handleTab: handleTab, autofocus: autofocus, restoreFocus: restoreFocus };
};
exports.useFocusScope = useFocusScope;
//# sourceMappingURL=useFocusScope.js.map